<template>
    <div>
        <Boyo-Dialog :dialogInfo="dialogInfoData"
                    @dialogEvent="dialogEventData">
            <div style="display:flex;margin-bottom:10px;margin-left: 10px;">
                <el-select v-model="filterInfo.data.factoryAreaId" filterable clearable placeholder="请选择所属单位" size="small" >
                    <el-option
                    v-for="item in listTypeInfo.factoryAreaId"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-if="!processId" v-model="filterInfo.data.processId" filterable clearable placeholder="请选择审批流程" size="small" >
                    <el-option
                    v-for="item in listTypeInfo.processId"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
                <el-button style="background-color:#3c414b;color:#fff;margin-left:20px" size="small" @click="filterTableInfo">搜索</el-button>
                <el-button v-if="!processId" style="background-color:#fff;color:#3c414b;margin-left:10px;border:1px silid #3c414b" size="small" @click="refresh">重置</el-button>
            </div>
            <div :v-loading="content.loading">
                <Boyo-Table :tableInfo="tableInfo"
                    :filterInfo="filterInfo.data"
                    :refObj.sync="tableInfo.ref"
                    :listTypeInfo="listTypeInfo"
                    @TableEvent="TableEvent"
                    @handleSizeChange="handleSizeChange"
                    @handleCurrentChange="handleCurrentChange">
                    <template v-slot:col-button2="scope">    
                        <el-button size="mini"
                                    style="background:#2a7cc9;padding: 6px 12px;"
                                    @click="TableEvent(scope.index,scope.row,'detail')">审核详情</el-button>
                        <el-button size="mini"
                                    style="background:#2a7cc9;padding: 6px 12px;"
                                    @click="TableEvent(scope.index,scope.row,'dataDetails')">数据</el-button> 
                    </template> 
                </Boyo-Table>
            </div>
        </Boyo-Dialog>
        
        <Boyo-Dialog :dialogInfo="dialogInfoDataDetails"
                    @dialogEvent="dialogEventDataDetails">
            <div style="display: flex; flex-direction: row; align-items: flex-start;">
                <!-- 左侧竖向步骤条 -->
                <div style="width: 240px; min-width: 220px; margin-right: 24px;">
                    <el-steps direction="vertical" :active="activeValue">
                        <el-step v-for="(itemf, index) of activeList" :key="index" :title="itemf.processNodeName" :status="itemf.stepStatus || 'process'">
                            <template slot="description">
                                <div v-if="itemf.processNodeName === '制单人'">
                                    {{ itemf.approvalTime }}
                                </div>
                                <div v-else>
                                    <div style="border-top: 1px solid #e4e7ed; margin: 8px 0;"></div>
                                    <div>流程节点：{{ itemf.processNodeName || '' }}</div>
                                    <div>经办人：{{ itemf.maker || '' }}</div>
                                    <div v-if="itemf.stepStatus !== 'process'">备注：{{ itemf.remark || (itemf.stepStatus === 'success' ? '通过' : '拒绝') }}</div>
                                    <div>时间：{{ itemf.makerTime || '' }}</div>
                                </div>
                            </template>
                        </el-step>
                    </el-steps>
                </div>
                <!-- 右侧内容 -->
                <div style="flex: 1; overflow-x: auto;">
                    <!-- 表单部分 -->
                    <Boyo-Formtwo :formInfo="formInfoDataDetails"
                               :refObj.sync="formInfoDataDetails.ref"
                               :listTypeInfo="listTypeInfo"
                               @formremoteMethod="formremoteMethod">
                    </Boyo-Formtwo>
                    
                    <!-- 非评铁审批的表格 -->
                    <div style="width: 100%; overflow-x: auto;">
                        <Boyo-Table :tableInfo="tableInfoDataDetails" v-if="dataDetailsTable && tableInfoDataDetails.processId != 'jgb_sp'"
                                :listTypeInfo="listTypeInfo">
                            <template v-slot:col-bankCardImageA="scope">
                                <a class="el-icon-view" v-if="scope.row.bankCardImageA"
                                            @click="priceFileView(scope.row,'bankCardImageA')">查看
                                </a>
                                <span v-if="!scope.row.bankCardImageA">暂无</span>
                            </template>
                            <template v-slot:col-bankCardImageB="scope">
                                <a class="el-icon-view" v-if="scope.row.bankCardImageB"
                                            @click="priceFileView(scope.row,'bankCardImageB')">查看
                                </a>
                                <span v-if="!scope.row.bankCardImageB">暂无</span>
                            </template>
                            <template v-slot:col-image="scope">
                                <a class="el-icon-view" v-if="scope.row.image"
                                    @click="viewInvoiceFile(scope.row.image)">查看
                                </a>
                                <span v-else>暂无</span>
                            </template>
                        </Boyo-Table>
                    </div>
                </div>
            </div>
            
            <!-- 审核表单 -->
            <div v-if="showAuditDataFields" style="margin-top: 20px; border-top: 1px solid #ebeef5; padding-top: 20px;">
                <!-- 添加快捷短语区域 -->
                <div class="quick-phrase-area">
                    <div class="quick-phrase-label">常用快捷短语:</div>
                    <div class="quick-phrase-buttons">
                        <el-button 
                            v-for="(phrase, index) in quickPhrases" 
                            :key="index"
                            size="mini"
                            @click="insertQuickPhrase(phrase)"
                            class="phrase-btn">
                            {{ phrase }}
                        </el-button>
                    </div>
                </div>
                
                <Boyo-Formtwo :formInfo="formInfoAuditData"
                           :refObj.sync="formInfoAuditData.ref"
                           :listTypeInfo="listTypeInfo"
                           @formremoteMethod="formremoteMethod">
                </Boyo-Formtwo>
            </div>
        </Boyo-Dialog>
        
        <PaymentDetail-Dialog ref="PaymentDetailDialog" v-if="PaymentDetailDialogShow" @approvalInfo="approvalInfo"></PaymentDetail-Dialog>
        <PaymentAdvDetail-Dialog ref="PaymentAdvDetailDialog" v-if="PaymentAdvDetailDialogShow" @approvalInfo="approvalInfo"></PaymentAdvDetail-Dialog>
        <SettleDetail-Dialog ref="SettleDetailDialog" v-if="SettleDetailDialogShow" @approvalInfo="approvalInfo"></SettleDetail-Dialog>
        <WarehousingEntry-Dialog ref="WarehousingEntryDialog" v-if="WarehousingEntryDialogShow" @approvalInfo="approvalInfo"></WarehousingEntry-Dialog>
        <WorkContactLetter-Dialog ref="WorkContactLetterDialog" v-if="WorkContactLetterDialogShow" @approvalInfo="approvalInfo"></WorkContactLetter-Dialog>
        <ApplicationForm-Dialog ref="ApplicationFormDialog" v-if="ApplicationFormDialogShow" @approvalInfo="approvalInfo"></ApplicationForm-Dialog>
        <LoadingVerification-Dialog ref="LoadingVerificationDialog" v-if="LoadingVerificationDialogShow" @approvalInfo="approvalInfo"></LoadingVerification-Dialog>
        <LogisticsContract-Dialog ref="LogisticsContractDialog" v-if="LogisticsContractDialogShow" @approvalInfo="approvalInfo"></LogisticsContract-Dialog>
        <AccessList-Dialog ref="AccessListDialog" v-if="AccessListDialogShow" @approvalInfo="approvalInfo"></AccessList-Dialog>
        <FreightSettlement-Dialog ref="FreightSettlementDialog" v-if="FreightSettlementDialogShow" @approvalInfo="approvalInfo"></FreightSettlement-Dialog>
        <FreightPayment-Dialog ref="FreightPaymentDialog" v-if="FreightPaymentDialogShow" @approvalInfo="approvalInfo"></FreightPayment-Dialog>
        <InternalWeighingDialog ref="InternalWeighingDialog" v-if="InternalWeighingDialogShow" @approvalInfo="approvalInfo"></InternalWeighingDialog>
        <InvoiceDetail-Dialog ref="InvoiceDetailDialog" v-if="InvoiceDetailDialogShow"></InvoiceDetail-Dialog>
        <QuoteApproval-Dialog ref="QuoteApprovalDialog" v-if="QuoteApprovalDialogShow"></QuoteApproval-Dialog>
        <DeliveryNotice-Dialog ref="DeliveryNoticeDialog" v-if="DeliveryNoticeDialogShow"></DeliveryNotice-Dialog>
        <EvaluationDialog ref="EvaluationDialog" v-if="EvaluationDialogShow" @approvalInfo="approvalInfo"></EvaluationDialog>
        <DeliveryDialog ref="DeliveryDialog" v-if="DeliveryDialogShow"></DeliveryDialog>
        <PurchaseHeavyVehiclesDialog ref="PurchaseHeavyVehiclesDialog" v-if="PurchaseHeavyVehiclesDialogShow"></PurchaseHeavyVehiclesDialog>
        <CustomerCreditLimit-Dialog ref="CustomerCreditLimitDialog" v-if="CustomerCreditLimitDialogShow" @approvalInfo="approvalInfo"></CustomerCreditLimit-Dialog>
        
        <!-- 图片预览组件，z-index 调高，保证在所有弹窗之上 -->
        <el-image-viewer
          v-if="showImageViewer"
          :on-close="closeImageViewer"
          :url-list="imageViewerList"
          :initial-index="imageViewerIndex"
          :z-index="9999"
        />
    </div>
</template>
<script>
import BoyoDialog from '@/components/BoyoDialog'
import BoyoFormtwo from '@/components/BoyoFormtwo'
import BoyoTable from '@/components/BoyoTable'
import PaymentDetailDialog from '@/components/Custom/PaymentDetailDialog'
import PaymentAdvDetailDialog from '@/components/Custom/PaymentAdvDetailDialog'
import SettleDetailDialog from '@/components/Custom/SettleDetailDialog'
import WarehousingEntryDialog from '@/components/Custom/WarehousingEntryDialog'
import WorkContactLetterDialog from '@/components/Custom/WorkContactLetterDialog'
import ApplicationFormDialog from '@/components/Custom/ApplicationFormDialog'
import LoadingVerificationDialog from '@/components/Custom/LoadingVerificationDialog'
import LogisticsContractDialog from '@/components/Custom/LogisticsContractDialog'
import AccessListDialog from '@/components/Custom/AccessListDialog'
import FreightSettlementDialog from '@/components/Custom/FreightSettlementDialog'
import FreightPaymentDialog from '@/components/Custom/FreightPaymentDialog'
import InternalWeighingDialog from '@/components/Custom/InternalWeighingDialog'
import InvoiceDetailDialog from '@/components/Custom/InvoiceDetailDialog'
import QuoteApprovalDialog from '@/components/Custom/QuoteApprovalDialog'
import DeliveryNoticeDialog from '@/components/Custom/DeliveryNoticeDialog'
import EvaluationDialog from '@/components/Custom/EvaluationDialog'
import DeliveryDialog from '@/components/Custom/DeliveryDialog'
import PurchaseHeavyVehiclesDialog from '@/components/Custom/PurchaseHeavyVehiclesDialog'
import CustomerCreditLimitDialog from '@/components/Custom/CustomerCreditLimitDialog'
import config from '@/api/config'
import axios from '@/api/axios'
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
  name: 'MyExpens',
  props: {
    
  },
  components:{
    BoyoDialog,
    BoyoFormtwo,
    BoyoTable,
    ElImageViewer,
    PaymentDetailDialog,
    PaymentAdvDetailDialog,
    SettleDetailDialog,
    WarehousingEntryDialog,
    WorkContactLetterDialog,
    ApplicationFormDialog,
    LoadingVerificationDialog,
    LogisticsContractDialog,
    AccessListDialog,
    FreightSettlementDialog,
    FreightPaymentDialog,
    InternalWeighingDialog,
    InvoiceDetailDialog,
    QuoteApprovalDialog,
    DeliveryNoticeDialog,
    EvaluationDialog,
    DeliveryDialog,
    PurchaseHeavyVehiclesDialog,
    CustomerCreditLimitDialog
  },
data () {
    return {
        activeValue:null,
        activeList:[],
        pingImgUrl: config.pingImgUrl,
        search: {},
        // 图片预览相关
        showImageViewer: false,
        imageViewerList: [],
        imageViewerIndex: 0,
        currentTaskId: null, // 当前审核任务ID
        detailDate:{},
        tableData:[],
        currentProcessData: null, // 存储当前流程数据
        currentDataSourcesId: null, // 存储当前数据源ID
        processId:'',
        roleId:localStorage.roleId,
        userId:localStorage.userId,
        dataDetailsTable:false,
        PaymentDetailDialogShow:false,
        PaymentAdvDetailDialogShow:false,
        SettleDetailDialogShow:false,
        WarehousingEntryDialogShow:false,
        WorkContactLetterDialogShow:false,
        ApplicationFormDialogShow:false,
        LoadingVerificationDialogShow:false,
        LogisticsContractDialogShow:false,
        AccessListDialogShow:false,
        FreightSettlementDialogShow:false,
        FreightPaymentDialogShow:false,
        InternalWeighingDialogShow:false,
        InvoiceDetailDialogShow:false,
        QuoteApprovalDialogShow:false,
        DeliveryNoticeDialogShow:false,
        EvaluationDialogShow:false,
        DeliveryDialogShow:false,
        PurchaseHeavyVehiclesDialogShow:false,
        CustomerCreditLimitDialogShow:false,
        quickPhrases: [
            '同意',
            '不同意',
            '需要补充相关附件',
            '合同',
            '供应商',
        ],
        showPhraseManager: false,
        newPhrase: '',
        content:{
            loading:false,
            text:''
        },
        listTypeInfo:{
            processId:[],
            forbidStatus:[{value:0,label:'启用'},{value:1,label:'停用'}],
            factoryAreaId:[],
            isDesignate:[{value:0,label:'指定角色'},{value:1,label:'指定审批人'}],
            approverId:[],
            roleId:[],
            status:[{value:0,label:'未开始'},{value:1,label:'进行中'},{value:2,label:'结束'}],
            statusFlag2:[{value:1,label:'同意'},{value:2,label:'不同意'}],
            publicFlag: [{ value: 0, label: '有组织' }, { value: 1, label: '无组织' }],
            naturalPerson: [{ value: 0, label: '否' }, { value: 1, label: '是' }],
            invoiceType:[{ value: 0, label: '正向开票' }, { value: 1, label: '反向开票' }],
            deliveryMode: [{ value: 0, label: '自提' }, { value: 1, label: '包运' }],
            meterType:[{ value: 1, label: '我方磅重' }, { value: 2, label: '对方磅重' }],
            freeItem3: [{ value: 0, label: '否' }, { value: 1, label: '是' }],
            purMode :[],
            transportMode:[{ value: 0, label: '未确定' }, { value: 1, label: '车运' }, { value: 2, label: '船运' }, { value: 3, label: '集装箱' }],
            pricingType:[{ value: 0, label: '评铁价' }, { value: 1, label: '合同价' }],
            invoiceStatus: [{ value: 0, label: '正常' }, { value: 1, label: '异常' }],
            positiveInvoice: [{ value: 0, label: '是' }, { value: 1, label: '否' }],
        },
        filterInfo: {
            visible: null, // 是否显示
            data: {
                factoryAreaId:'',
                processId:'',
                status:1,
                pageNum: 1,
                pageSize: 50
            }
        },
        dialogInfoData: {
            visible: false, // 弹框是否显示
            width: '1200px', // 宽度
            title: {
                add: '我的待办', // 标题
            },
            type: 'add', // 显示哪个标题
            // 按钮列表
            btList: [
                { label: '关闭', type: '', icon: '', event: 'close', loading: false }
            ]
        },
        dialogInfoDataDetails: {
            visible: false, // 弹框是否显示
            width: '90%', // 宽度增加到90%，几乎占满整个屏幕
            title: {
                update: "对应数据详情" // 标题
            },
            type: 'update', // 显示哪个标题
            // 按钮列表
            btList: [
                { label: '审核', type: 'success', icon: '', event: 'save', loading: false ,show:false},
                { label: '关闭', type: '', icon: '', event: 'close', loading: false }
            ]
        },
        formInfoDataDetails: {
            ref: null,
            labelWidth: '25%',
            inline:true,
            data: {
            },
            list: [
            ],
            rules: {
            }
        },
        formInfoAuditData: {
            ref: null,
            labelWidth: '100px',
            // inline:true,
            data: {
                id:'',
                factoryAreaId:'',
                factoryAreaCode:'',
                factoryAreaName:'',
                processId:'',
                remark:'',
                status:'',
            },
            list: [
                { type: 'select流程名称：', label: '流程名称：', value: 'processId', list: 'processId', style: 'width:80%',disabled:true},
                { type: 'selectRadio', label: '审核：', value: 'status', style: 'width:95%', className: 'form_item_one',list:'statusFlag2',unclearable:true},
                { type: 'text', label: '备注：', value: 'remark', style: 'width:80%'},
            ],
            rules: {
                status:[{ required: true, trigger: 'change',message: '请选择' }]
            }
        },
        showAuditDataFields: false,
        //表格相关
        tableInfo: {
            selection: false, //是否显示表格单选框
            xuhao: true,//序号显示隐藏
            selectReset: null,//重置单选框选中
            mode: null,//表格模板one和two两种
            height:'420px',
            data: [],//数据
            total: 0,//总条数
            pager: true,
            multipleSelection: [],//表格单选框数据
            fieldList: [
                { value: 'name', label: '流程名称', show: true, dropdown: true,},
                { value: 'status', label: '流程状态',list:'status', show: true, dropdown: true,width:'110'},
                { value: 'dataSourcesCode', label: '单据编号', show: true, dropdown: true,width:'110'},
                { value: 'superiorApprpver', label: '上一级审批人', show: true, dropdown: true,width:'120'},
                { value: 'superiorApprpverTime', label: '上一级审批时间', show: true, dropdown: true,width:'140'},
                { value: 'approver', label: '当前审批人', show: true, dropdown: true,width:'100'},
                { value: 'roleName', label: '当前审批角色', show: true, dropdown: true,width:'120'},
                { value: 'updateTime', label: '更新时间', show: true, dropdown: true,width:'140'},
                { value: 'button2', label: '操作', type: 'slot', show: true, dropdown: true,width:"150" ,fixed:'right',align:'left'}
            ],
            btList: []
        },
        tableInfoDataDetails: {
            height:250,
            selection: false, //是否显示表格单选框
            xuhao: true,//序号显示隐藏
            selectReset: null,//重置单选框选中
            mode: null,//表格模板one和two两种
            data: [],//数据
            total: 0,//总条数
            pager: false,
            multipleSelection: [],//表格单选框数据
            fieldList: [
            ],
            btList: []
        },     
    }
  },
mounted(){
    this.getInfo()
    this.loadProcessEnumData()
    this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {//枚举（流程标识）
        if(res.code == 0) {
            let list1 = res.data.list
            for( let i in list1 ) {
                this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
            }
        }
    })
    this.$api.dictionary.getSysEnumPage({pageNum: 1, pageSize: 999,enumCategoryCode:'PurMode'}).then(res => {
        if(res.code == 0) {
            let list1 = res.data.list
            for( let i in list1 ) {
                this.listTypeInfo.purMode.push({value: Number(list1[i].enumName), label: list1[i].enumValue})
            }
        }
    })
    this.$api.system.getSysUserAreaPage({pageNum:1,pageSize:0,userId:JSON.parse(localStorage.personal).userId}).then(res => {
        if (res.code === 0) {
            for (let i in res.data.list) {
            this.listTypeInfo.factoryAreaId.push({value:res.data.list[i].factoryAreaId,label:res.data.list[i].factoryAreaName,code:res.data.list[i].factoryAreaCode })
            }
        }else{
            this.$message({ message: res.msg, type: 'error' })
        }
    })
    this.$api.role.getSysRolePage({ status: 1 ,pageNum:1,pageSize:900}).then(res => {
        let arr = []
        for (let i in res.data.list) {
            arr.push({value:res.data.list[i].roleId+'',label:res.data.list[i].roleName})
        }
        this.listTypeInfo.roleId = arr //角色
    })
    this.$api.employee.getBaseEmployeePage({pageNum: 1, pageSize: 9999,tflag:0}).then(res => {//员工
        if(res.code == 0) {
            for(let inde of res.data.list){
            this.listTypeInfo.approverId.push({value:inde.id+'',label:inde.employeename,employeeno:inde.employeeno})
            }
        }
    })
  },
  
methods: {
    loadProcessEnumData() {
        this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
            if(res.code == 0) {
                let list1 = res.data.list
                this.listTypeInfo.processId = [] // 清空重新加载
                for(let i in list1) {
                    this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
                }
            }
        })
    },
    priceFileView(row,text){
        // 弹窗预览图片，而不是打开新窗口
        const imageUrl = this.pingImgUrl + row[text]
        this.imageViewerList = [imageUrl]
        this.imageViewerIndex = 0
        this.showImageViewer = true
    },
    // 预览单张图片
    previewImage(imageUrl) {
        this.imageViewerList = [imageUrl]
        this.imageViewerIndex = 0
        this.showImageViewer = true
    },
    // 关闭图片预览
    closeImageViewer() {
        this.showImageViewer = false
    },
    viewInvoiceFile(fileUrl) {
        if (fileUrl) {
            // 如果已经是完整URL，直接打开
            if (fileUrl.startsWith('http')) {
                window.open(fileUrl);
            } else {
                // 否则拼接基础URL
                window.open(this.pingImgUrl + fileUrl);
            }
        }
    },
    dialogShow(data,processId){
        if(data == '我的待办审核'){
            this.dialogInfoData.title.add = '我的待办'
            this.processId = ''
            this.filterInfo.data.processId = ''
            this.getInfo()
        }else{
            this.dialogInfoData.title.add = data + '我的待办'
            this.processId = processId
            this.filterInfo.data.processId = processId
            this.getInfo()
        }
        this.dialogInfoData.visible = true
    },
    getInfo(){
        let parm = this.filterInfo.data
        this.content.loading = true
        this.content.text = ''
        this.tableInfo.data = []
        parm.approverId = localStorage.userId
        parm.roleId = localStorage.roleId
        this.$api.system.getActProcessInstancePage(parm).then(res => {
            this.content.loading = false
            if (res.code == 0) {
                this.tableInfo.data = res.data.list
                this.tableInfo.total = Number(res.data.total)
            }else{
                this.$message({ message: res.msg, type: 'error' })
            }
        },
        err => {
            console.log(err)
        }
    )},
    dialogEventData(event){
        const dialogInfoData = this.dialogInfoData
        switch (event) {
            case 'close':
                dialogInfoData.visible = false
                break
        }
    },
    //表格内部按钮事件
    TableEvent (index, data, event) {
        switch (event) {
            case 'detail':
                this.content.loading = true
                this.$api.system.getActProcessEntryPage({idProcessInstance:data.id,pageNum:1,pageSize:999}).then(res => {
                    this.content.loading = false
                    if (res.code === 0) {
                        const currentTask = res.data.list.find(item => !item.status)
                        if (currentTask) {
                            this.currentTaskId = currentTask.id
                        } else {
                            this.currentTaskId = null
                        }
                        this.dialogInfoDataDetails.btList[0].show = true
                        data.auditDialog = 0
                        
                        // 设置当前流程数据和数据源ID
                        this.currentProcessData = { ...data }
                        this.currentDataSourcesId = data.dataSourcesId
                        
                        // 查找当前流程的枚举信息
                        const currentEnum = this.listTypeInfo.processId.find(
                            item => item.enumValue === data.processId
                        )
                        
                        // 先加载详情数据，然后再显示弹窗
                        this.detailsGet(data)
                        
                        // 使用setTimeout确保数据加载完成后再显示弹窗和审核表单
                        setTimeout(() => {
                            this.$nextTick(() => {
                                // 初始化审核表单数据
                                for (const key in this.formInfoAuditData.data) {
                                    this.formInfoAuditData.data[key] = ''
                                }
                                this.formInfoAuditData.data.factoryAreaId = data.factoryAreaId
                                
                                // 查找并设置流程名称
                                let processFound = false;
                                for (let inde of this.listTypeInfo.processId) {
                                    if (data.processId == inde.enumValue) {
                                        this.formInfoAuditData.data.processId = inde.value
                                        processFound = true;
                                        break;
                                    }
                                }
                                
                                if (!processFound) {
                                    console.warn('未找到匹配的流程ID:', data.processId)
                                    this.formInfoAuditData.data.processId = data.processId;
                                }
                                
                                this.formInfoAuditData.data.status = 1
                                this.showAuditDataFields = true
                            })
                        }, 300)
                    } else {
                        this.$message({ message: res.msg, type: 'error' })
                    }
                }).catch(() => {
                    this.content.loading = false
                })
                break
            case 'dataDetails':
                this.content.loading = true
                
                // 先确保流程枚举值已加载
                const loadProcessEnum = () => {
                    return new Promise((resolve) => {
                        if (this.listTypeInfo.processId && this.listTypeInfo.processId.length > 0) {
                            resolve();
                        } else {
                            this.$api.ThirdPartyInterface.getActProcessConfigPage({pageNum: 1, pageSize: 999,carTypeArray:[2,3], status:1}).then(res => {
                                if(res.code == 0) {
                                    let list1 = res.data.list
                                    this.listTypeInfo.processId = [] // 清空重新加载
                                    for(let i in list1) {
                                        this.listTypeInfo.processId.push({value: list1[i].processId, enumValue: list1[i].processCode, label: list1[i].name})
                                    }
                                    resolve();
                                } else {
                                    this.$message({ message: '加载流程枚举失败: ' + res.msg, type: 'error' })
                                    resolve();
                                }
                            }).catch(() => {
                                resolve();
                            });
                        }
                    });
                };
                
                // 加载流程枚举后再继续处理
                loadProcessEnum().then(() => {
                    this.$api.system.getActProcessEntryPage({idProcessInstance:data.id,pageNum:1,pageSize:999}).then(res => {
                        this.content.loading = false
                        if (res.code === 0) {
                            const currentTask = res.data.list.find(item => !item.status)
                            if (currentTask) {
                                this.currentTaskId = currentTask.id
                            } else {
                                this.currentTaskId = null
                            }
                            this.dialogInfoDataDetails.btList[0].show = false
                            data.auditDialog = 0
                            
                            // 设置当前流程数据和数据源ID
                            this.currentProcessData = { ...data }
                            this.currentDataSourcesId = data.dataSourcesId
                            
                            // 查找当前流程的枚举信息
                            const currentEnum = this.listTypeInfo.processId.find(
                                item => item.enumValue === data.processId
                            )
                            
                            // 先加载详情数据，然后再显示弹窗
                            this.detailsGet(data)
                            
                            // 使用setTimeout确保数据加载完成后再显示弹窗
                            setTimeout(() => {
                                this.$nextTick(() => {
                                    this.showAuditDataFields = false
                                })
                            }, 300)
                        } else {
                            this.$message({ message: res.msg, type: 'error' })
                        }
                    }).catch(() => {
                        this.content.loading = false
                    })
                });
                break
        }
    },
    detailsGet(data){
        this.$api.system.getActProcessEntryPage({idProcessInstance:data.id,pageNum:1,pageSize:999}).then(res => {
            if (res.code == 0) {
                this.activeList = []
                this.activeValue = 0
                for (let i in res.data.list) {
                    if(res.data.list[i].status && i < res.data.list.length){
                        this.activeValue = Number(Number(i) + 1)
                    }
                    let stepStatus = 'process';
                    if (res.data.list[i].status == 1) {
                        stepStatus = 'success';
                    } else if (res.data.list[i].status == 2) {
                        stepStatus = 'error';
                    } else {
                        stepStatus = 'process';
                    }
                    this.activeList.push({
                        processNodeName: res.data.list[i].processNodeName || '', // 第一行：流程节点名称
                        maker: res.data.list[i].status
                          ? res.data.list[i].actualApprover
                          : (res.data.list[i].approver ? res.data.list[i].approver : res.data.list[i].roleName), // 第二行：经办人
                        remark: res.data.list[i].remark || '', // 第三行：备注
                        makerTime: res.data.list[i].approvalTime || '', // 第四行：时间
                        stepStatus
                    })
                }
                // 始终在最前面插入"制单人"节点
                let maker = data ? data.createBy : data.approver?data.approver:'无';
                let makerTime = (data && data.createTime) ? data.createTime : '';
                let approvalTime = maker + (makerTime ? (' ' + makerTime) : '');
                this.activeList.unshift({ processNodeName: '制单人', approvalTime });
                this.activeValue = (this.activeValue || 0) + 1;
            }else{
                this.$message({ message: res.msg, type: "error" });
            }
        })
        this.tableInfoDataDetails.processId = data.processId
        // 重置表单和表格数据
        this.formInfoDataDetails.data = {}
        this.formInfoDataDetails.list = []
        this.tableInfoDataDetails.data = []
        this.tableInfoDataDetails.fieldList = []
        
        if(data.processId == 'gys_add_sp' || data.processId == 'cys_add_sp'){
            this.dataDetailsTable = true
            this.formInfoDataDetails.data = {
                factoryAreaId:'',
                partnerId:'',
                partnerCode:'',
                partnerCode: '',
                partnerName: '',
                partnerGroup: '',
                principal: '',
                phone: '',
                taxRate: '',
                address:'',
                site:'',
                openBank:'',
                bankId:'',
                bankName:'',
                partnerRemark: '',
                partnerType: '',
                carrierFlag:'',
                alias:'',
                departureId:'',
                payeeId:'',
                payeeName:'',
                recipientId:'',
                recipientName:'',
                idCard:'',
                ratepayerNo:'',
                publicFlag:'',
                corporateRepresentative:'',
                naturalPerson:'',
                taxBurden:'',
                businessLicense:'',
                businessPermit:'',
                accountLicense:'',
                taxpayerForm:'',
                filingCertificate:'',
                circulationService:'',
                creditCertificate:'',
                idCardImageA:'',
                idCardImageB:'',
                qualificationPositive:'',
                idAddress:'',
                idCardEndDate:'',
                invoiceLimit:'',
            }
            this.formInfoDataDetails.list=[
                { type: 'text', label: '名称：', value: 'partnerName', style: 'width:90%', className: 'form_item_two', required: true,disabled:true},
                { type: 'numberPhone', label: '电话：', value: 'phone', style: 'width:90%', className: 'form_item_two', required: true,disabled:true},
                { type: 'text', label: '开票额度：', value: 'invoiceLimit', style: 'width:90%', className: 'form_item_two',disabled:true,showType:'0',shows:true,show:true},
                { type: 'text', label: '税负：', value: 'taxBurden', style: 'width:90%', className: 'form_item_two',disabled:true,showType:'0',shows:true,show:true},
                { type: 'text', label: '身份证号：', value: 'idCard', style: 'width:90%', className: 'form_item_two', required: true,disabled:true,showType:'0',shows:true,show:true},
                { type: 'text', label: '身份证地址：', value: 'idAddress', style: 'width:90%', className: 'form_item_two',disabled:true,showType:'0',shows:true,show:true},
                { type: 'text', label: '地址：', value: 'idAddress', style: 'width:90%', className: 'form_item_two',disabled:true,showType:'1',shows:true,show:true},
                { type: 'text', label: '身份证到期：', value: 'idCardEndDate', style: 'width:90%', className: 'form_item_two', required: true,disabled:true,showType:'0',shows:true,show:true},
                { type: 'textarea', label: '备注：', value: 'partnerRemark', style: 'width:90%', className: 'form_item_two',disabled:true},
                { type: 'uploads', label: '身份证正面', labelContent: '人像面', value: 'idCardImageA', style: 'width:90%', className: 'form_item_two',fileListHt:[],disabled:true,showType:'0',shows:true,show:true},
                { type: 'uploads', label: '身份证反面', labelContent: '国徽面', value: 'idCardImageB', style: 'width:90%', className: 'form_item_two',fileListHt:[],disabled:true,showType:'0',shows:true,show:true},
                { type: 'uploadThree', label: '资格证明：', value: 'qualificationPositive', style: 'width:90%', className: 'form_item_two',fileListHt:[],disabled:true,showType:'0',shows:true,show:true},
                { type: 'uploadThree', label: '汇算清缴：', value: 'settlementImage', style: 'width:90%', className: 'form_item_two',fileListHt:[],disabled:true,showType:'0',shows:true,show:true},
                { type: 'uploadThree', label: '开户许可证：', value: 'accountLicense', style: 'width:90%', className: 'form_item_two',showType:'1',fileListHt:[],disabled:true,shows:true,show:true},
                { type: 'uploadThree', label: '信用等级：',labelContent:'纳税人信用等级证明', value: 'creditCertificate', style: 'width:90%', className: 'form_item_two',showType:'1',fileListHt:[],disabled:true,shows:true,show:true},
                { type: 'uploadThree', label: '流通服务：',labelContent:'商务部绿色流通服务', value: 'circulationService', style: 'width:90%', className: 'form_item_two',showType:'1',fileListHt:[],disabled:true,shows:true,show:true},
                { type: 'uploadThree', label: '经营备案：',labelContent:'再生资源经营备案证明', value: 'filingCertificate', style: 'width:90%', className: 'form_item_two',showType:'1',fileListHt:[],disabled:true,shows:true,show:true},
                { type: 'uploadThree', label: '纳税认定表：',labelContent:'一般纳税人认定表', value: 'taxpayerForm', style: 'width:90%', className: 'form_item_two',showType:'1',fileListHt:[],disabled:true,shows:true,show:true},
                { type: 'uploadThree', label: '经营许可证：', value: 'businessPermit', style: 'width:90%', className: 'form_item_two',showType:'0',fileListHt:[],disabled:true,shows:true,show:true},
            ]
            this.tableInfoDataDetails.fieldList = [
                { value: 'subBank', label: '银行', show: true, dropdown: true, sortable: true },
                { value: 'bankAccount', label: '银行账号', show: true, dropdown: true, sortable: true },
                { value: 'bankName', label: '开户名称', show: true, dropdown: true, sortable: true },
                { value: "bankCardImageA",  label: "银行卡正面", type: 'slot', show: true, dropdown: true },
                { value: "bankCardImageB",  label: "银行卡反面", type: 'slot', show: true, dropdown: true },
            ]
            // 直接使用 dataSourcesJson 数据
            try {
                let sourceData = data.dataSourcesJson ? JSON.parse(data.dataSourcesJson) : null
                
                // 如果解析后还是字符串，再解析一次
                if (typeof sourceData === 'string') {
                    sourceData = JSON.parse(sourceData)
                }
                
                if (sourceData) {
                    // 填充表单数据
                    for (const key in sourceData) {
                        if (key in this.formInfoDataDetails.data) {
                            this.formInfoDataDetails.data[key] = sourceData[key]
                        }
                    }
                    // 1. 所有可能出现图片的字段
                    const imgKeys = ['businessPermit','taxpayerForm', 'filingCertificate', 'circulationService','creditCertificate', 'accountLicense', 'settlementImage','qualificationPositive','idCardImageB','idCardImageA']
                    
                    // 2. 遍历表单配置，精准匹配
                    this.formInfoDataDetails.list.forEach(item => {
                        if (item.type === 'uploadThree' && imgKeys.includes(item.value)) {
                            const url = sourceData && sourceData[item.value]
                            console.log(item.label,item.value,sourceData[item.value])
                            if (url) {
                                const fileName = url.split('/').pop() || 'unknown';
                                const fullUrl = url;
                                item.fileListHt = [{ name: fileName, url: fullUrl }];
                                // 添加点击预览功能
                                item.onPreview = (file) => {
                                    this.previewImage(fullUrl);
                                };
                            } else {
                                item.fileListHt = [];
                            }
                        }
                        // 根据承运商显示/隐藏字段
                        if(item.shows){
                            item.show = false
                        }
                        if(this.formInfoDataDetails.data.carrierFlag == 1 &&(item.showType == '1' || item.label == '经营许可证：')){
                            item.show = true
                        }else if(!this.formInfoDataDetails.data.carrierFlag && this.formInfoDataDetails.data.partnerType && (item.showType == '0'|| item.label == '经营许可证：')){
                            item.show = true
                        }else if(!this.formInfoDataDetails.data.carrierFlag && !this.formInfoDataDetails.data.partnerType && item.showType == '0'){
                            if(item.label != '资格证明：' && item.label != '汇算清缴：' && item.label != '经营许可证：'){
                                item.show = true
                            }
                        }
                    });
                    // 根据自然人标识显示/隐藏字段
                    // this.formInfoDataDetails.list.forEach(uyt=>{
                    //     if(uyt.shows){
                    //         uyt.show = false
                    //     }
                    //     if(sourceData.naturalPerson == 1 && uyt.showType == '1' && (sourceData.publicFlag == 0 || uyt.label == '有组织/无组织：' || uyt.label == '身份证：')){
                    //         uyt.show = true
                    //     }else if(sourceData.naturalPerson == 0 && uyt.showType == '0'){
                    //         uyt.show = true
                    //     }
                    // })
                    // 填充银行信息表格 - 从 dataSourcesJson 中获取
                    if (sourceData.basePartnerBankList && Array.isArray(sourceData.basePartnerBankList)) {
                        this.tableInfoDataDetails.data = sourceData.basePartnerBankList
                        this.tableInfoDataDetails.total = sourceData.basePartnerBankList.length
                    } else {
                        this.tableInfoDataDetails.data = []
                        this.tableInfoDataDetails.total = 0
                    }
                    
                    if(!data.auditDialog){
                        this.dialogInfoDataDetails.title.update = (data.processId == 'gys_add_sp' && this.formInfoDataDetails.data.partnerType && !this.formInfoDataDetails.data.carrierFlag)?'供应商对应数据':(data.processId == 'gys_add_sp' && !this.formInfoDataDetails.data.partnerType)?'客户对应数据':'承运商对应数据'
                        this.dialogInfoDataDetails.visible = true
                    }
                } else {
                    console.warn('数据为空')
                    this.$message({ message: '对应数据查找为空', type: 'warning' })
                    if(!data.auditDialog){
                        this.dialogInfoDataDetails.title.update = (data.processId == 'gys_add_sp' && this.formInfoDataDetails.data.partnerType && !this.formInfoDataDetails.data.carrierFlag)?'供应商对应数据':(data.processId == 'gys_add_sp' && !this.formInfoDataDetails.data.partnerType)?'客户对应数据':'承运商对应数据'
                        this.dialogInfoDataDetails.visible = true
                    }
                }
            } catch (error) {
                console.error('解析供应商 dataSourcesJson 失败:', error, 'dataSourcesJson:', data.dataSourcesJson)
                this.$message({ message: '数据解析失败', type: 'error' })
                if(!data.auditDialog){
                    this.dialogInfoDataDetails.title.update = (data.processId == 'gys_add_sp' && this.formInfoDataDetails.data.partnerType && !this.formInfoDataDetails.data.carrierFlag)?'供应商对应数据':(data.processId == 'gys_add_sp' && !this.formInfoDataDetails.data.partnerType)?'客户对应数据':'承运商对应数据'
                    this.dialogInfoDataDetails.visible = true
                }
            }
        }else if(data.processId.includes('ht_add_sp')){
            this.dataDetailsTable = true
            this.formInfoDataDetails.data = {
                id: null,
                billNo: '',
                billDate: '',
                purMode: '',
                invoiceType: '',
                idMeterFactoryArea: '',
                areaName: '',
                baseAreaId: '',
                baseAreaName: '',
                baseAreaAssistantId: '',
                baseAreaAssistantName: '',
                contractId:'',
                partnerId:'',
                businessCode:'',
                partnerName:'',
                partnerAddress:'',
                partnerPhone:'',
                partnerContacts:'',
                departureId:'',
                departureName:'',
                phone:'',
                logMenuName:'',
                logMenuCode:'',
                stkOutMaterialEntrySaveFormList:[],
                contractName:'',
                partnerIdNumber:'',
                partnerLegalPerson:'',
                partnerBankId:'',
                partnerBank:'',
                partnerBankAccount:'',
                partnerBankName:'',
                meterType:'',
                contractBeginDate:'',
                contractEndDate:'',
                contractDeliveryBeginDate:'',
                contractDeliveryEndDate:'',
                payeeId:'',
                payeeName:'',
                employeeId:'',
                employeeName:'',
                deliveryMode:'',
                prepaymentFlag:'',
                advanceRatio:'',
                pricingType:'',
                transportMode:'',
                totalTaxRate:'',
                totalTaxRateTwo:'',
                floatingQuantity:'',
                floatingQuantityTwo:'',
                contractNote: '',
                businessLicense:'',
                idCardImageA:'',
                idCardImageB:'',
                bankCardImageA:'',
                bankCardImageB:'',
                video:'',
                freeItem1:'',
                attachment:'',
                purFlag:'',
                parentId:'',
                parentIdText:'',
                purUnit:'',
                publicFlag:'',
                contractCode:'',
                orderDate:'',
                factoryAreaId:'',
                partnerId:'',
                partnerName:'',
                partnerIdCar:'',
                idAddress:'',
                createBy:'',
            }
            this.tableInfoDataDetails.fieldList = [
                { value: 'materialNo', label: '物料编号', show: true, dropdown: true, width: 90, fixed: 'left'},
                { value: 'materialName', label: '物料名称', show: true, dropdown: true, width: 200},
                { value: 'materialSpec', label: '物料规格', show: true, dropdown: true, width: 100},
                { value: 'purUnit', label: '采购单位', show: true, dropdown: true, width: 90},
                { value: 'remark', label: '备注', show: true, dropdown: true},
            ]
            
            this.tableInfoDataDetails.fieldList[0].show = false
            this.formInfoDataDetails.list=[
                {type: "dateDay",label: "合同日期：",value: "orderDate", style: 'width:95%', className: 'form_item_two',disabled:true},
                {type: "select开票类型：",label: "开票类型：",value: "invoiceType", style: 'width:95%', className: 'form_item_two',list:'invoiceType',unclearable:true,disabled:true},
                {type: "periodDays",label: "合同有效期：",datetime:'date',value1: "contractBeginDate", value2: "contractEndDate", style: 'width:95%', className: 'form_item_two',disabled:true},
                {type: "text",label: "合同编号：",value: "contractCode", style: 'width:95%', className: 'form_item_two',disabled:true},
                {type: "select所属单位：",label: "所属单位：",value: "factoryAreaId", style: 'width:95%', className: 'form_item_two',list:'factoryAreaId',disabled:true},
                {type: "select供应商：",label: "供应商：",value: "partnerName", style: 'width:95%', className: 'form_item_two',list:'partnerId',disabled:true},
                {type: "numberPhone",label: "供应商电话：",value: "partnerPhone", style: 'width:95%', className: 'form_item_two',disabled:true},
                { type: "text", label: "身份证：", value: "partnerIdCar", style: 'width:95%', className: 'form_item_two', disabled:true },
                { type: 'text', label: '身份证地址：', value: 'idAddress', style: 'width:95%', className: 'form_item_two', disabled:true },
                {type: 'text', label: '供应商银行：', value: 'partnerBank', style: 'width:95%', className: 'form_item_two',disabled:true},
                {type: "text",label: "银行账号：",value: "partnerBankAccount", style: 'width:95%', className: 'form_item_two',disabled:true},
                {type: "text",label: "账号户名：",value: "partnerBankName", style: 'width:95%', className: 'form_item_two',disabled:true},
                {type: "select付款单位：",label: "付款单位：",value: "payeeName", style: 'width:95%', className: 'form_item_two',list:'payeeId',unclearable:true,disabled:true},
                {type: "text",label: "制单人：",value: "createBy", style: 'width:95%', className: 'form_item_two',list:'payeeId',unclearable:true,disabled:true},
                {type: "text",label: "备注：",value: "contractNote", style: 'width:95%', className: 'form_item_two',disabled:true},
                // { type: 'uploadThree', label: '申请附件：', value: 'freeItem1', style: 'width:95%;margin-top: -90px;', className: 'form_item_two',fileListHt:[], disabled:true },
                { type: 'uploads', label: '身份证正面：', labelContent: '人像面', value: 'idCardImageA', style: 'width:95%', className: 'form_item_two', disabled: true },
                { type: 'uploads', label: '身份证反面：', labelContent: '国徽面', value: 'idCardImageB', style: 'width:95%', className: 'form_item_two', disabled: true },
                { type: 'uploads', label: '银行卡正面：', value: 'bankCardImageA', style: 'width:95%', className: 'form_item_two', disabled: true },
                { type: 'uploads', label: '银行卡反面：', value: 'bankCardImageB', style: 'width:95%', className: 'form_item_two', disabled: true },
                { type: 'uploadThree', label: '合同存档：', value: 'attachment', style: 'width:95%;margin-top: -90px;', className: 'form_item_two',fileListHt:[], disabled:true },
            ]
            
            // 直接使用 dataSourcesJson 数据
            try {
                // dataSourcesJson 是双重转义的JSON字符串，需要两次解析
                let sourceData = data.dataSourcesJson ? JSON.parse(data.dataSourcesJson) : null
                
                // 如果解析后还是字符串，再解析一次
                if (typeof sourceData === 'string') {
                    sourceData = JSON.parse(sourceData)
                }
                
                if (sourceData) {
                    // 填充表单数据
                    for (const key in sourceData) {
                        if (key in this.formInfoDataDetails.data) {
                            this.formInfoDataDetails.data[key] = sourceData[key]
                        }
                    }
                    if (this.formInfoDataDetails.list[this.formInfoDataDetails.list.length - 1]) {
                        this.formInfoDataDetails.list[this.formInfoDataDetails.list.length - 1].fileListHt = []
                        if (sourceData.attachment) {
                        this.formInfoDataDetails.list[this.formInfoDataDetails.list.length - 1].fileListHt = [{name: (sourceData.attachment.split('-').length > 2)?sourceData.attachment.split('-')[2]:sourceData.attachment.split('-')[1],url: sourceData.attachment,id: data.id}]
                        }
                    }
                    // 填充表格数据 - 使用 purOrderEntryList
                    if (sourceData.purOrderEntryList && Array.isArray(sourceData.purOrderEntryList)) {
                        this.tableInfoDataDetails.data = sourceData.purOrderEntryList
                        this.tableInfoDataDetails.total = sourceData.purOrderEntryList.length
                    } else {
                        this.tableInfoDataDetails.data = []
                        this.tableInfoDataDetails.total = 0
                    }
                    
                    if(!data.auditDialog){
                        this.dialogInfoDataDetails.title.update = '合同对应数据'
                        this.dialogInfoDataDetails.visible = true
                    }
                } else {
                    this.$message({ message: '对应数据查找为空', type: 'warning' })
                }
            } catch (error) {
                console.error('解析 dataSourcesJson 失败:', error, 'dataSourcesJson:', data.dataSourcesJson)
                this.$message({ message: '数据解析失败', type: 'error' })
            }

        }else if(data.processId == 'sf_add_sp'){
            this.dataDetailsTable = true
            this.formInfoDataDetails.data = {
                execDate:''
            }
            this.tableInfoDataDetails.fieldList = [
                { value: 'factoryAreaName', label: '所属单位', show: true, dropdown: true },
                { value: 'partnerName', label: '供应商名称', show: true, dropdown: true},
                { value: 'taxBurden', label: '当前税负%', show: true, dropdown: true},
                { value: 'updTaxBurden', label: '修改税负%', show: true, dropdown: true},
                { value: 'updateTime', label: '修改时间', show: true, dropdown: true, width: 160}
            ]
            
            // 直接使用 dataSourcesJson 数据
            try {
                // dataSourcesJson 格式: "[{\"id\":\"xxx\",\"partnerId\":\"xxx\",\"updTaxBurden\":11,...}]"
                let sourceData = data.dataSourcesJson ? JSON.parse(data.dataSourcesJson) : null
                
                // 如果解析后是字符串，再次解析
                if (typeof sourceData === 'string') {
                    sourceData = JSON.parse(sourceData)
                }
                
                if (sourceData) {
                    // 如果 sourceData 是数组，直接使用
                    if (Array.isArray(sourceData)) {
                        this.tableInfoDataDetails.data = sourceData
                        this.tableInfoDataDetails.total = sourceData.length
                    } 
                    // 如果是对象且包含 partnerList
                    else if (sourceData.partnerList && Array.isArray(sourceData.partnerList)) {
                        this.tableInfoDataDetails.data = sourceData.partnerList
                        this.tableInfoDataDetails.total = sourceData.partnerList.length
                    } 
                    // 如果是单个对象，包装成数组
                    else if (typeof sourceData === 'object') {
                        this.tableInfoDataDetails.data = [sourceData]
                        this.tableInfoDataDetails.total = 1
                    } 
                    else {
                        this.tableInfoDataDetails.data = []
                        this.tableInfoDataDetails.total = 0
                    }
                    
                    if(!data.auditDialog){
                        this.dialogInfoDataDetails.title.update = '税负对应数据'
                        this.dialogInfoDataDetails.visible = true
                    }
                } else {
                    this.$message({ message: '对应数据为空', type: 'warning' })
                }
            } catch (error) {
                console.error('解析 dataSourcesJson 失败:', error, 'dataSourcesJson:', data.dataSourcesJson)
                this.$message({ message: '数据解析失败', type: 'error' })
            }
        } else if(data.processId == 'fp_sp' || data.processId == 'fxfp_sp'){
            this.showDialogWithMaker({
                refName: 'InvoiceDetailDialog',
                showFlagName: 'InvoiceDetailDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data
            });
        } else if(data.processId == 'fkd_sp'){
            this.showDialogWithMaker({
                refName: 'PaymentDetailDialog',
                showFlagName: 'PaymentDetailDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data,
                extra: () => {
                    if(data.auditDialog){
                        this.formInfoDataDetails.data = this.$refs.PaymentDetailDialog.formInfo2.data
                        this.formInfoDataDetails.list = this.$refs.PaymentDetailDialog.formInfo2.list
                    }
                }
            })
        } else if(data.processId == 'yfk_sp'){
            this.showDialogWithMaker({
                refName: 'PaymentAdvDetailDialog',
                showFlagName: 'PaymentAdvDetailDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data,
                extra: () => {
                    if(data.auditDialog){
                        this.formInfoDataDetails.data = this.$refs.PaymentAdvDetailDialog.formInfo2.data
                        this.formInfoDataDetails.list = this.$refs.PaymentAdvDetailDialog.formInfo2.list
                    }
                }
            })
        } else if(data.processId == 'jsd_sp'){
            this.showDialogWithMaker({
                refName: 'SettleDetailDialog',
                showFlagName: 'SettleDetailDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data,
                extra: () => {
                    if(data.auditDialog){
                        this.formInfoDataDetails.data = this.$refs.SettleDetailDialog.formInfo2.data
                        this.formInfoDataDetails.list = this.$refs.SettleDetailDialog.formInfo2.list
                    }
                }
            })
        } else if(data.processId == 'rkd_sp'){
            this.showDialogWithMaker({
                refName: 'WarehousingEntryDialog',
                showFlagName: 'WarehousingEntryDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data,
                extra: () => {
                    if(data.auditDialog){
                        this.formInfoDataDetails.data = this.$refs.WarehousingEntryDialog.formInfo2.data
                        this.formInfoDataDetails.list = this.$refs.WarehousingEntryDialog.formInfo2.list
                    }
                }
            })
        } else if(data.processId == 'gzllh_sp'){
            this.showDialogWithMaker({
                refName: 'WorkContactLetterDialog',
                showFlagName: 'WorkContactLetterDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data,
                extra: () => {
                    if(data.auditDialog){
                        this.formInfoDataDetails.data = this.$refs.WorkContactLetterDialog.formInfo2.data
                        this.formInfoDataDetails.list = this.$refs.WorkContactLetterDialog.formInfo2.list
                    }
                }
            })
        } else if(data.processId == 'sqb_sp'){
            this.showDialogWithMaker({
                refName: 'ApplicationFormDialog',
                showFlagName: 'ApplicationFormDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data,
                extra: () => {
                    if(data.auditDialog){
                        this.formInfoDataDetails.data = this.$refs.ApplicationFormDialog.formInfo2.data
                        this.formInfoDataDetails.list = this.$refs.ApplicationFormDialog.formInfo2.list
                    }
                }
            })
        } else if(data.processId == 'zg_fh_sp'){
            this.showDialogWithMaker({
                refName: 'LoadingVerificationDialog',
                showFlagName: 'LoadingVerificationDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data,
                extra: () => {
                    if(data.auditDialog){
                        this.formInfoDataDetails.data = this.$refs.LoadingVerificationDialog.formInfo2.data
                        this.formInfoDataDetails.list = this.$refs.LoadingVerificationDialog.formInfo2.list
                    }
                }
            })
        } else if(data.processId == 'yfht_sp'){
            this.showDialogWithMaker({
                refName: 'LogisticsContractDialog',
                showFlagName: 'LogisticsContractDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data,
                extra: () => {
                    if(data.auditDialog){
                        this.formInfoDataDetails.data = this.$refs.LogisticsContractDialog.formInfo2.data
                        this.formInfoDataDetails.list = this.$refs.LogisticsContractDialog.formInfo2.list
                    }
                }
            })
        } else if(data.processId == 'pt_upd_sp' || data.processId == 'htpt_dj_sp'){
            this.showDialogWithMaker({
                refName: 'AccessListDialog',
                showFlagName: 'AccessListDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data,
                extra: () => {
                    if(data.auditDialog){
                        this.formInfoDataDetails.data = this.$refs.AccessListDialog.formInfo2.data
                        this.formInfoDataDetails.list = this.$refs.AccessListDialog.formInfo2.list
                    }
                }
            })
        } else if(data.processId == 'fhtzd_sp'){
            this.showDialogWithMaker({
                refName: 'DeliveryNoticeDialog',
                showFlagName: 'DeliveryNoticeDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data,
                extra: () => {
                    if(data.auditDialog){
                        this.formInfoDataDetails.data = this.$refs.DeliveryNoticeDialog.formInfo2.data
                        this.formInfoDataDetails.list = this.$refs.DeliveryNoticeDialog.formInfo2.list
                    }
                }
            })
        } else if(data.processId == 'bjd_sp'){
            this.showDialogWithMaker({
                refName: 'QuoteApprovalDialog',
                showFlagName: 'QuoteApprovalDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data,
                extra: () => {
                    if(data.auditDialog){
                        this.formInfoDataDetails.data = this.$refs.QuoteApprovalDialog.formInfo2.data
                        this.formInfoDataDetails.list = this.$refs.QuoteApprovalDialog.formInfo2.list
                    }
                }
            })
        } else if(data.processId == 'yfjs_sp'){
            this.showDialogWithMaker({
                refName: 'FreightSettlementDialog',
                showFlagName: 'FreightSettlementDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data,
                extra: () => {
                    if(data.auditDialog){
                        this.formInfoDataDetails.data = this.$refs.FreightSettlementDialog.formInfo2.data
                        this.formInfoDataDetails.list = this.$refs.FreightSettlementDialog.formInfo2.list
                    }
                }
            })
        } else if(data.processId == 'yffk_sp'){
            this.showDialogWithMaker({
                refName: 'FreightPaymentDialog',
                showFlagName: 'FreightPaymentDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data,
                extra: () => {
                    if(data.auditDialog){
                        this.formInfoDataDetails.data = this.$refs.FreightPaymentDialog.formInfo2.data
                        this.formInfoDataDetails.list = this.$refs.FreightPaymentDialog.formInfo2.list
                    }
                }
            })
        } else if (data.processId == 'yk_jsd_sp'){
            this.showDialogWithMaker({
                refName: 'InternalWeighingDialog',
                showFlagName: 'InternalWeighingDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data,
                extra: () => {
                    if(data.auditDialog){
                        this.formInfoDataDetails.data = this.$refs.InternalWeighingDialog.formInfo2.data
                        this.formInfoDataDetails.list = this.$refs.InternalWeighingDialog.formInfo2.list
                    }
                }
            })
        } else if (data.processId == 'jgb_sp'){
            this.showDialogWithMaker({
                refName: 'EvaluationDialog',
                showFlagName: 'EvaluationDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data,
                extra: () => {
                    if(data.auditDialog){
                        this.formInfoDataDetails.data = this.$refs.EvaluationDialog.formInfo2.data
                        this.formInfoDataDetails.list = this.$refs.EvaluationDialog.formInfo2.list
                    }
                }
            })
        } else if (data.processId == 'kccc_sp'){
            this.showDialogWithMaker({
                refName: 'DeliveryDialog',
                showFlagName: 'DeliveryDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data,
                extra: () => {
                    if(data.auditDialog){
                        this.formInfoDataDetails.data = this.$refs.DeliveryDialog.formInfo2.data
                        this.formInfoDataDetails.list = this.$refs.DeliveryDialog.formInfo2.list
                    }
                }
            })
        } else if (data.processId == 'zccc_sp'){
            this.showDialogWithMaker({
                refName: 'PurchaseHeavyVehiclesDialog',
                showFlagName: 'PurchaseHeavyVehiclesDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data,
                extra: () => {
                    if(data.auditDialog){
                        this.formInfoDataDetails.data = this.$refs.PurchaseHeavyVehiclesDialog.formInfo2.data
                        this.formInfoDataDetails.list = this.$refs.PurchaseHeavyVehiclesDialog.formInfo2.list
                    }
                }
            })
        } else if (data.processId == 'khxyed_sp') {
            this.showDialogWithMaker({
                refName: 'CustomerCreditLimitDialog',
                showFlagName: 'CustomerCreditLimitDialogShow',
                dataSourcesId: data.dataSourcesId,
                auditDialog: data.auditDialog ? 1 : 0,
                auditParm: this.currentTaskId ? {id: this.currentTaskId, processId: data.processId} : null,
                id: data.id,
                data
            })
        }
    },
    // 修改 dialogEventDataDetails 方法
    dialogEventDataDetails (event) {
        const dialogInfoDataDetails = this.dialogInfoDataDetails
        switch (event) {
            case 'save':
                this.formInfoAuditData.ref.validate(valid => {
                    if (valid) {
                        let parma = this.formInfoAuditData.data
                        dialogInfoDataDetails.btList[0].loading = true
                        
                        // 根据 enumValue 查找对应的枚举项，获取 freeItem0
                        let currentProcessEnum = null
                        let processEnumValue = ''
                        
                        // 优先从 currentProcessData 中获取 processId (enumValue)
                        if (this.currentProcessData && this.currentProcessData.processId) {
                            processEnumValue = this.currentProcessData.processId
                            currentProcessEnum = this.listTypeInfo.processId.find(
                                item => item.enumValue === processEnumValue
                            )
                        }
                        
                        // 如果没找到，尝试从表单数据中反向查找
                        if (!currentProcessEnum && parma.processId) {
                            // 通过 value 找到对应的 enumValue
                            const tempEnum = this.listTypeInfo.processId.find(
                                item => item.value === parma.processId
                            )
                            if (tempEnum) {
                                processEnumValue = tempEnum.enumValue
                                currentProcessEnum = this.listTypeInfo.processId.find(
                                    item => item.enumValue === processEnumValue
                                )
                            }
                        }
                        
                        // 准备提交数据
                        const submitData = {
                            id: this.currentTaskId,
                            processId:parma.processId,
                            status: parma.status,
                            remark: parma.remark,
                            dataSourcesId: this.currentDataSourcesId,
                            factoryAreaId: parma.factoryAreaId
                        }
                        
                        // 判断是否是最后一道审批
                        const isLastApproval = this.checkIsLastApproval()
                        
                        // 如果是最后一道审批且审批通过(状态为1)且有freeItem0接口，调用动态接口
                        if (currentProcessEnum && currentProcessEnum.freeItem0) {
                            if (parma.status === 2 || (parma.status === 1 && isLastApproval)) {
                                // 调用动态接口的情况：
                                // 1. 不同意（不管是不是最后一道审批）
                                // 2. 同意且是最后一道审批
                                this.submitToDynamicApi(currentProcessEnum.freeItem0, submitData, dialogInfoDataDetails)
                            } else {
                                // 同意但不是最后一道审批，走普通流程
                                this.submitNormalApprovalDirectly(submitData, dialogInfoDataDetails)
                            }
                        } else {
                            // 没有freeItem0接口，走普通审批流程
                            this.submitNormalApprovalDirectly(submitData, dialogInfoDataDetails)
                        }
                    }
                })
                break
            case 'close':
                dialogInfoDataDetails.visible = false
                this.showAuditDataFields = false
                // 重置当前流程数据
                this.currentProcessData = null
                this.currentDataSourcesId = null
                // 关闭弹窗后刷新列表
                this.getInfo()
                break
        }
    },
    submitNormalApprovalDirectly(submitData, dialogInfo) {
        this.$api.system.approval(submitData).then(res => {
            if (res.code === 0) {
                const statusText = submitData.status === 1 ? '同意' : '拒绝'
                this.$message({ message: `审批${statusText}成功`, type: 'success' })
                dialogInfo.visible = false
                this.showAuditDataFields = false
                this.getInfo()
            } else {
                this.$message({ message: res.msg || '审核失败', type: 'error' })
            }
        }).catch(error => {
            console.error('审批接口调用失败:', error)
            this.$message({ message: '接口调用失败，请检查网络连接', type: 'error' })
        }).finally(() => {
            dialogInfo.btList[0].loading = false
        })
    },
    submitToDynamicApi(apiPath, submitData, dialogInfo) {
        // 构建完整的API URL
        const fullApiUrl = this.buildFullApiUrl(apiPath)
        
        if (!fullApiUrl) {
            this.$message({ message: '动态接口配置错误', type: 'error' })
            dialogInfo.btList[0].loading = false
            return
        }
        // 先调用普通审批流程完成审批
        this.submitNormalApproval(submitData, dialogInfo, () => {
            // 审批成功后调用动态接口，确保状态正确传递
            this.callFinalApprovalApi(fullApiUrl, submitData, dialogInfo)
        })
    },
    callFinalApprovalApi(apiUrl, submitData, dialogInfo) {
        // 准备审批数据，确保状态正确传递
        const finalApprovalData = {
            id: this.currentProcessData ? this.currentProcessData.id : submitData.id, // 流程实例ID
            dataSourcesId: submitData.dataSourcesId, // 业务数据ID（如供应商ID）
            status: submitData.status, // 确保状态正确传递（1同意，2不同意）
            remark: submitData.remark,
            factoryAreaId: submitData.factoryAreaId
        }
        // 使用 axios 直接调用动态接口
        axios({
            url: apiUrl,
            method: 'post',
            data: finalApprovalData
        }).then(res => {
            dialogInfo.visible = false
            this.showAuditDataFields = false
            this.getInfo()
        }).catch(error => {
            console.error('动态接口调用失败:', error)
            const statusText = submitData.status === 1 ? '同意' : '拒绝'
            dialogInfo.visible = false
            this.showAuditDataFields = false
            this.getInfo()
        }).finally(() => {
            dialogInfo.btList[0].loading = false
        })
    },
    submitNormalApproval(submitData, dialogInfo, callback) {
        this.$api.system.approval(submitData).then(res => {
            if (res.code === 0) {
                this.$message({ message: res.msg, type: 'success' })
                
                // 如果有回调函数，执行回调
                if (callback && typeof callback === 'function') {
                    callback()
                } else {
                    // 没有回调时直接关闭
                    dialogInfo.visible = false
                    this.showAuditDataFields = false
                    this.getInfo()
                    dialogInfo.btList[0].loading = false
                }
            } else {
                this.$message({ message: res.msg, type: 'error' })
                dialogInfo.btList[0].loading = false
            }
        }).catch(() => {
            dialogInfo.btList[0].loading = false
        })
    },
    buildFullApiUrl(apiPath) {
        if (!apiPath) return null
        
        // 如果已经是完整URL，直接使用
        if (apiPath.startsWith('http')) {
            return apiPath
        }
        
        // 如果是相对路径，添加基础URL
        if (apiPath.startsWith('/')) {
            // 根据你的实际API基础URL进行调整
            // 使用系统配置的 baseURL
            const baseUrl = config.baseURL
            return baseUrl + apiPath
        }
        
        // 如果是API路径，确保以/开头
        return '/api/' + (apiPath.startsWith('/') ? apiPath.substring(1) : apiPath)
    },
    checkIsLastApproval() {
        if (!this.activeList || this.activeList.length === 0) return false
            
        // 找到当前活跃的步骤（状态为 process 的步骤，排除制单人）
        const currentStepIndex = this.activeList.findIndex(item => 
            item.stepStatus === 'process' && item.processNodeName !== '制单人'
        )
        
        if (currentStepIndex !== -1) {
            // 检查后面是否还有未完成的审批步骤
            const remainingSteps = this.activeList.slice(currentStepIndex + 1)
            const hasRemainingApprovalSteps = remainingSteps.some(item => 
                item.processNodeName !== '制单人' && 
                item.stepStatus === 'process' &&
                !item.makerTime // 没有审批时间的步骤
            )
            return !hasRemainingApprovalSteps
        }
        
        return false
    },
    formremoteMethod(data, query, type){
        switch (type){
            case 'select所属单位：':
            break
        }
    },
    // 通用弹窗弹出方法，自动传递制单人和时间
    showDialogWithMaker({
        refName,
        showFlagName,
        dataSourcesId,
        auditDialog = null,
        auditParm = null,
        id,
        data,
        extra,
    }) {
        this[showFlagName] = true;
        this.$nextTick(() => {
            let maker = data ? data.createBy : (data && data.approver ? data.approver : '无');
            let makerTime = (data && data.createTime) ? data.createTime : '';
            let args = [dataSourcesId];
            if (auditDialog !== null) {
                args.push(auditDialog);
            } else {
                args.push(0);
            }
            if (auditParm !== null) {
                args.push(auditParm);
            } else {
                args.push(null);
            }
            args.push(id);
            args.push(maker);
            args.push(makerTime);
            this.$refs[refName].dialogShow.apply(this.$refs[refName], args);
            if (extra && typeof extra === 'function') {
                extra();
            }
        });
    },
    insertQuickPhrase(phrase) {
        // 获取当前备注值
        const currentRemark = this.formInfoAuditData.data.remark || '';
        
        // 插入短语到备注中
        if (currentRemark) {
            this.formInfoAuditData.data.remark = currentRemark + ' ' + phrase;
        } else {
            this.formInfoAuditData.data.remark = phrase;
        }
    },
    addNewPhrase() {
        if (this.newPhrase.trim()) {
            this.quickPhrases.push(this.newPhrase.trim());
            this.newPhrase = '';
        }
    },
    removePhrase(index) {
        this.quickPhrases.splice(index, 1);
    },
    approvalInfo(){
        this.dialogInfoDataDetails.visible = false
        this.showAuditDataFields = false
        this.$emit('approvalInfo')
    },
    filterTableInfo(){
        this.getInfo()
    },
    refresh(){
        this.filterInfo.data.processId = ''
        this.filterInfo.data.factoryAreaId = ''
        this.getInfo()
    },
    // 切换分页大小
    handleSizeChange (pageSize) {
        this.filterInfo.data.pageSize = pageSize
        this.filterInfo.data.pageNum = 1
        this.getInfo()
    },
    // 切换页数
    handleCurrentChange (pageNum) {
        this.filterInfo.data.pageNum = pageNum
        this.getInfo()
    }
  }
}
</script>
<style lang="stylus" scoped>
.avatar-uploader
  border-style dashed
  border-color #d9d9d9
  border-width 1px
  border-radius 6px
  width 150px
  cursor pointer
  position relative
  overflow hidden

.avatar-uploader:hover 
  border-color #409EFF

.avatar-uploader-icon
  font-size 28px
  color #8c939d
  width 150px
  height 150px
  line-height 150px
  text-align center
.avatar-uploader-icon2
  font-size 20px
  color #8c939d
  width 40px
  height 40px
  line-height 40px
  text-align center
.avatar
  width 150px
  height 150px
  display block
.uploadTip
  font-size 15px

.quick-phrase-area {
  margin-bottom: 15px;
  padding: 10px;
  background-color: #f5f7fa;
  border-radius: 4px;
  border: 1px dashed #dcdfe6;
}

.quick-phrase-label {
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #606266;
}

.quick-phrase-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.phrase-btn {
  margin: 0;
  white-space: nowrap;
}

.phrase-manager-btn {
  margin: 0;
}

.phrase-manager {
  max-height: 400px;
  overflow-y: auto;
}

.phrase-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.phrase-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-delete-btn {
  flex-shrink: 0;
}

.phrase-add {
  display: flex;
  margin-top: 15px;
}

.phrase-add-input {
  flex: 1;
  margin-right: 10px;
}

.phrase-add-btn {
  flex-shrink: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Custom/MyAuditDialog.vue